import Pesquisa from './Pesquisa.vue'

const PesquisaRouter = {
  path: '/pesquisa/:json64',
  component: Pesquisa
}

export default PesquisaRouter
